import React from 'react';

import { WeezSocket } from "@weezevent/piglet";
import  Loader from "./../../loader";
import { Connect } from "@weezevent/connect";

const fragments = window.location.hash.split("#");

const parseQuery = (query) => query.split("&")
    .map(pair => pair.split("="))
    .reduce((result, [key, value]) => {
        result[key] = decodeURIComponent(value);
        return result;
    }, {});

const getFromAccounts = () => {
    const query = parseQuery(window.location.hash.slice(1));
    return query.access_token ? query : null;
};

export const hasFragmentPreview = () => {
    const _fragments = window.location.hash.split("#");
    return _fragments.find(fragment => fragment === 'weez_preview');
}

class RedirectDriver {
    resolve() {
        // we should not resolve from the redirect driver
        // Either its ok at open, or it's redirected and lost
    }

    open(url) {
        //Case preview widget in nBO
        if (window.location !== window.parent.location) {
            return new Promise(resolve => {
                WeezSocket.listen();
                WeezSocket.send({ type: "request_token", origin: "neo", payload: { } }, { needs_answer: true }).then(msg => {
                    resolve({access_token: msg.payload.token});
                });
            });
        }

        const payload = getFromAccounts();
        if (payload) {
            // We came back from accounts already!

            // clear the hash, that contained the authentication token
            const url = new URL(window.location);

            const redirectUriSplitted = decodeURIComponent(payload.state).split("#");
            url.hash = redirectUriSplitted.slice(1).join('#');
            url.pathname = redirectUriSplitted[0] || "/";

            // Redirect to the initial uri
            window.history.replaceState({}, "", url);
            console.log('resolve Redirect');

            // resolve now
            return payload;
        }

        // Redirect to accounts in order to be connected
        let new_url = new URL(url);
        let params = new_url.searchParams;
        params.set("state", `${params.get("state")}${fragments.join('#')}`)

        // Go to accounts
        window.location.assign(new_url);
        // After the location is changed, this page won't resolve.
        // A new page will load at the end of the authentication
        return new Promise(resolve => {});
    }
}


function NeoConnect({children}) {
    return (
        (hasFragmentPreview() || getFromAccounts()) ? (
            <Connect
                config={window.weezConfig.connect}
                redirectPath="/ticket/"
                driver={new RedirectDriver()}
                fallback={ <Loader/> }
            >
                { children }
            </Connect>
        ) : (
            <>
                { children }
            </>
        )
    );
}

export default NeoConnect;
